document.addEventListener('DOMContentLoaded', function () {
    // ----------------------------------------------------
    // スライド (Swiper) の制御
    // ----------------------------------------------------
    const swiperContainer = document.querySelector('.mySwiper');
    if (swiperContainer) {
        const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
        const originalSlides = swiperWrapper.querySelectorAll('.swiper-slide');
        const originalCount = originalSlides.length;
        const minSlides = 8; 

        // スライド数が少ない場合にループを安定させるための複製
        if (originalCount > 1 && originalCount < minSlides) {
            const duplicateCount = Math.ceil(minSlides / originalCount);
            for (let i = 1; i < duplicateCount; i++) {
                originalSlides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    clone.classList.add('is-clone');
                    swiperWrapper.appendChild(clone);
                });
            }
        }

        const swiper = new Swiper('.mySwiper', {
            loop: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            roundLengths: true,
            loopedSlides: 5,
            observer: true,
            observeParents: true,
            spaceBetween: 5, 
            speed: 600,
            initialSlide: 0,
            autoplay: { delay: 4000, disableOnInteraction: false },
            pagination: false,
            breakpoints: { 769: { spaceBetween: 10 } },
        });

        // ページネーションのカスタム描画
        const paginationEl = swiperContainer.querySelector('.swiper-pagination');
        if (paginationEl) {
            paginationEl.innerHTML = '';
            for (let i = 0; i < originalCount; i++) {
                const bullet = document.createElement('span');
                bullet.classList.add('swiper-pagination-bullet');
                if (i === 0) bullet.classList.add('swiper-pagination-bullet-active');
                bullet.addEventListener('click', () => { swiper.slideToLoop(i); });
                paginationEl.appendChild(bullet);
            }
            const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
            swiper.on('slideChange', function () {
                const realIndex = this.realIndex % originalCount;
                bullets.forEach((bullet, index) => {
                    if (index === realIndex) {
                        bullet.classList.add('swiper-pagination-bullet-active');
                    } else {
                        bullet.classList.remove('swiper-pagination-bullet-active');
                    }
                });
            });
        }
    }

    // ----------------------------------------------------
    // ハンバーガーメニュー & アコーディオン制御
    // ----------------------------------------------------
    const hamburger = document.getElementById('js-hamburger');
    const nav = document.getElementById('js-global-nav');
    const closeBtn = document.getElementById('js-drawer-close');
    const overlay = document.getElementById('js-overlay');
    
    function toggleDrawer() {
        if(nav) nav.classList.toggle('is-active');
        if(overlay) overlay.classList.toggle('is-active');
        if(hamburger) hamburger.classList.toggle('is-active');
    }

    if(hamburger) hamburger.addEventListener('click', toggleDrawer);
    if(closeBtn) closeBtn.addEventListener('click', toggleDrawer);
    if(overlay) overlay.addEventListener('click', toggleDrawer);

    // スマホ用アコーディオン
    const navItemsWithSub = document.querySelectorAll('.global-nav__item.has-sub');
    navItemsWithSub.forEach(item => {
        const link = item.querySelector('a');
        const trigger = item.querySelector('.sp-accordion-trigger');
        const content = item.querySelector('.global-nav__sub');

        const toggleSubMenu = (e) => {
            e.preventDefault(); 
            e.stopPropagation();
            if (trigger) trigger.classList.toggle('is-open');
            if (content) {
                content.style.display = (content.style.display === 'block') ? 'none' : 'block';
            }
        };

        if (link) link.addEventListener('click', toggleSubMenu);
        if (trigger) trigger.addEventListener('click', toggleSubMenu);
    });

    // ----------------------------------------------------
    // Q&Aナビ：SP用タップ制御
    // ----------------------------------------------------
    const qaNav = document.querySelector('.qa-nav');
    if (qaNav) {
        const qaDropdownItems = qaNav.querySelectorAll('.has-dropdown');
        const isSp = () => window.matchMedia('(max-width: 768px)').matches;

        const closeAllQaDropdowns = () => {
            qaDropdownItems.forEach(item => item.classList.remove('is-open'));
        };

        qaDropdownItems.forEach(item => {
            const parentLink = item.querySelector(':scope > a');
            if (!parentLink) return;

            parentLink.addEventListener('click', (e) => {
                if (!isSp()) return;
                if (!item.classList.contains('is-open')) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    closeAllQaDropdowns();
                    item.classList.add('is-open');
                }
            });
        });

        document.addEventListener('click', (e) => {
            if (isSp() && !qaNav.contains(e.target)) closeAllQaDropdowns();
        });
        
        window.addEventListener('resize', () => {
             if (!isSp()) closeAllQaDropdowns();
        });
    }

    // ----------------------------------------------------
    // スムーズスクロール
    // ----------------------------------------------------
    const easeOutQuad = (t) => t * (2 - t);
    const smoothScrollTo = (targetY, duration) => {
        const startY = window.pageYOffset;
        const distance = targetY - startY;
        let startTime = null;
        const animation = (currentTime) => {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const ease = easeOutQuad(progress);
            window.scrollTo(0, startY + distance * ease);
            if (timeElapsed < duration) requestAnimationFrame(animation);
        };
        requestAnimationFrame(animation);
    };

    const anchorLinks = document.querySelectorAll('a[href^="#"]:not(.global-nav__item.has-sub > a)');
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href === '#' || href === '') {
                e.preventDefault();
                return;
            }
            const target = document.getElementById(href.replace('#', ''));
            if (target) {
                e.preventDefault();
                const gap = 60; 
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - gap;
                smoothScrollTo(targetPosition, 500);
                if (nav && nav.classList.contains('is-active')) toggleDrawer();
            }
        });
    });

    // ----------------------------------------------------
    // 商品ページ：購入ボタンの追従 (Shopify Assetsパス考慮)
    // ----------------------------------------------------
    const stickyBtn = document.getElementById('js-sticky-btn');
    const stickyWrapper = document.getElementById('js-sticky-wrapper');

    if (stickyBtn && stickyWrapper) {
        let triggerY = 0;
        const recalcTrigger = () => {
            const rect = stickyWrapper.getBoundingClientRect();
            triggerY = window.scrollY + rect.top;
        };
        const update = () => {
            if (window.scrollY >= triggerY) {
                stickyBtn.classList.add('is-fixed');
                stickyBtn.classList.add('is-sticky');
                stickyWrapper.style.height = stickyBtn.offsetHeight + 'px';
            } else {
                stickyBtn.classList.remove('is-fixed');
                stickyBtn.classList.remove('is-sticky');
                stickyWrapper.style.height = '';
            }
        };
        recalcTrigger();
        update();
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', recalcTrigger);
        window.addEventListener('load', recalcTrigger);
    }

    // ----------------------------------------------------
    // 万能モーダル制御（画像・YouTube共用）
    // ----------------------------------------------------
    const modal = document.getElementById('js-common-modal');
    const modalContent = document.getElementById('js-modal-content');
    const modalOpenBtns = document.querySelectorAll('.js-modal-open');
    const modalCloseElements = document.querySelectorAll('.js-modal-close, .c-modal__overlay');

    if (modal && modalContent) {
        modalOpenBtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                const youtubeId = this.getAttribute('data-youtube');
                const imgSrc = this.getAttribute('data-img');
                
                modalContent.innerHTML = ''; // リセット

                if (youtubeId) {
                    // YouTubeの場合
                    modalContent.innerHTML = `
                        <div class="video-container">
                            <iframe src="https://www.youtube.com/embed/${youtubeId}?rel=0" 
                                    frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen></iframe>
                        </div>`;
                } else if (imgSrc) {
                    // 画像の場合
                    modalContent.innerHTML = `<img src="${imgSrc}" class="modal-image-auto" alt="拡大画像">`;
                }

                modal.classList.add('is-active');
                document.body.style.overflow = 'hidden'; // 背面のスクロールを止める
            });
        });

        // 閉じる処理を共通化
        const closeModal = () => {
            modal.classList.remove('is-active');
            modalContent.innerHTML = ''; // 動画を確実に止める
            document.body.style.overflow = '';
        };

        modalCloseElements.forEach(el => {
            el.addEventListener('click', closeModal);
        });
    }
});

